import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { S3TimeSeriesEditCard } from "./edit_card";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const S3TimeSeriesEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <S3TimeSeriesEditCard
          id={Number(id)}
          client={Clients.S3}
          table_name={Tables.S3_TIME_SERIES}
        />
        <TechnicalInfoCard
          id={Number(id)}
          table_name={Tables.S3_TIME_SERIES}
          client={Clients.S3}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.S3}
          audit_table_name={Tables.S3_TIME_SERIES}
        />
      </div>
    </div>
  );
};
